export type ResetPasswordErrorCodesTypes = string | "PASSWORD_RESET_ATTEMPT_LIMIT_REACHED" | "DEFAULT_ERROR";

export type ResetPasswordError = {
  error_code: null | ResetPasswordErrorCodesTypes;
  error?: string;
  retry_after_seconds?: number;
};
export enum ResetPasswordErrorCodes {
  PASSWORD_RESET_ATTEMPT_LIMIT_REACHED = "PASSWORD_RESET_ATTEMPT_LIMIT_REACHED",
}
